import { kebabCase } from 'es-toolkit';
import React, { Component } from 'react';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';

import { humanCase } from '@paragon/utilities';

import { EnumConfiguration } from '../properties/EnumProperty';
import { PropertyComponentProps } from './ModelProperty';

export class EnumPropertyComponent extends Component<PropertyComponentProps<string, EnumConfiguration>> {
  get configuration() {
    return this.props.schema.configuration;
  }

  onChange = (event: SelectChangeEvent) => {
    this.props.onEdit(event.target.value);
  };

  render() {
    const value = this.props.value !== null ? this.props.value : '';

    const inputId = `${kebabCase(this.props.name)}-input`;

    const unknownValue =
      !!value && Array.isArray(this.configuration.enum)
        ? !this.configuration.enum.includes(value)
        : !Object.prototype.hasOwnProperty.call(this.configuration.enum, value);

    let augmentedEnum = this.configuration.enum;
    if (unknownValue && Array.isArray(this.configuration.enum)) {
      augmentedEnum = [value, ...this.configuration.enum];
    } else if (unknownValue) {
      augmentedEnum = { [value]: value, ...this.configuration.enum };
    }

    const { required, readOnly, allowUnknownValues } = this.configuration;

    const label = humanCase(this.props.name);

    return (
      <FormControl
        variant="outlined"
        size="small"
        fullWidth
        required={required}
        error={(required && value === '') || (unknownValue && !allowUnknownValues)}
        disabled={readOnly || this.props.configuration.disabled}
      >
        <InputLabel htmlFor={inputId}>{label}</InputLabel>
        <Select inputProps={{ id: inputId }} onChange={this.onChange} value={value} label={label}>
          {Object.values(augmentedEnum).map((value) => (
            <MenuItem key={value} value={value}>
              {this.configuration.formatter(value)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }
}
